import { Delegate, animate } from "vendor";
import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod, waitForEvent, matchesMediaQuery, Modal, EffectCarousel, ScrollCarousel, DialogElement } from "theme";
import { __GHDConfiguratorBaseMaterials, __GHDConfiguratorCustomMaterials, _hexToRGB } from "ghd-configurator-materials";
import { createIdleObjectMatrixSway } from "ghd-configurator-camera-idle";

let _onSlideChanged, onSlideChanged_fn;
let GHDConfiguratorCarousel = class extends EffectCarousel {
	constructor() {
		super();
		
		__privateAdd(this, _onSlideChanged);
		this.addEventListener("carousel:change", __privateMethod(this, _onSlideChanged, onSlideChanged_fn));
		
	}

	
	createOnChangeAnimationControls(fromSlide, toSlide) {
		return {
			leaveControls: () => animate(fromSlide, { opacity: [1, 0], transform: ["translateY(0)", "translateY(15px)"] }, { duration: 0.3, easing: "ease-in" }),
			enterControls: () => animate(toSlide, { opacity: [0, 1], transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.2, delay: 0.2, easing: "ease-out" })
		};
	}
	
	get shouldUpdateSection() {
		return this.hasAttribute("update-section");
	}
	
	get shouldUpdateOptions() {
		return this.hasAttribute("update-options");
	}
};

_onSlideChanged = new WeakSet();
onSlideChanged_fn = function(event) {
    if (this.shouldUpdateSection) {
		this.dispatchEvent(new CustomEvent("configurator:section:change", {
			bubbles: true,
			detail: {
				view: event.detail.cell.getAttribute('view')
			}
		}));
	}

    if (this.shouldUpdateOptions) {
		this.dispatchEvent(new CustomEvent("configurator:option:change", {
			bubbles: true,
			detail: {
				view: event.detail.cell.getAttribute('view')
			}
		}));
	}
};

if (!window.customElements.get("ghd-configurator-carousel")) {
  window.customElements.define("ghd-configurator-carousel", GHDConfiguratorCarousel);
}



var GHDViewButton = class extends HTMLButtonElement {
  constructor() {
    super();
  }
  connectedCallback() {
      let _this = this;
	  
      this.addEventListener("click", (event) => {
		event.preventDefault();
		
		this.dispatchEvent(new CustomEvent("configurator:view:change", {
			bubbles: true,
			detail: {
				view: event.target.getAttribute('view')
			}
		}));
		
      });
  }
};
if (!window.customElements.get("ghd-view-button")) {
  window.customElements.define("ghd-view-button", GHDViewButton, { extends: "button" });
}



var PresetDialog = class extends DialogElement {
    createEnterAnimationControls() {
		return animate(this, { transform: ["translateY(120%)", "translateY(0)"] }, { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] });
    }
    createLeaveAnimationControls() {
		return animate(this, { transform: ["translateY(0)", "translateY(120%)"] }, { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] });
    }
};
if (!window.customElements.get("ghd-preset-dialog")) {
  window.customElements.define("ghd-preset-dialog", PresetDialog);
}


let _onSubmit_TeamShopForm, onSubmit_fn_TeamShopForm;
let TeamShopForm = class extends HTMLFormElement {
	constructor() {
		super();
		__privateAdd(this, _onSubmit_TeamShopForm);
		this.addEventListener("submit", __privateMethod(this, _onSubmit_TeamShopForm, onSubmit_fn_TeamShopForm));
	}
	connectedCallback() {
	    if (!this.configurator) {
	      throw "Team shop form component requires an aria-controls attribute that refers to the controlled configurator.";
	    }
	}
	
    get submissionUrl() {
      return this.getAttribute('custom-action');
    }
  
    get submissionApiKey() {
      return this.getAttribute('api-key');
    }
	
    get configurator() {
      return document.getElementById(this.getAttribute("aria-controls"));
    }
};

_onSubmit_TeamShopForm = new WeakSet();
onSubmit_fn_TeamShopForm = async function(event) {
	event.preventDefault();
	if (!this.checkValidity()) {
		this.reportValidity();
		return;
	}
	const _this = this;
	
	await _this.configurator.idle.stop();
	
	const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
	submitButtons.forEach((submitButton) => {
		submitButton.setAttribute("disabled", "disabled");
		submitButton.setAttribute("aria-busy", "true");
	});
	document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
	
	let frontData = '',
		backData = '',
		cameraPosition = '',
		cameraTarget = '',
		preset_config = [],
		shareUrl = '',
		imageName = '';
	
	Array.from(this.configurator.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).forEach(function (carousel) {
		let item = carousel.selectedCell;
		let values = [];
		Array.from(item.querySelectorAll('.color-picker__option-values :checked')).forEach(function (item_value) {
			values.push(item_value.closest('.material-card').getAttribute('material-colour-handle'));
		});
		
		preset_config.push({
			section: item.closest('.ghd-configurator-carousel').getAttribute('section'),
			material: item.getAttribute('material-handle'),
			values
		});
	});
	
	let json_preset = JSON.stringify({ "config": preset_config });
	let encodedURI = encodeURIComponent(json_preset);
	let url = window.location.origin + window.location.pathname + '?' + 'configurator=' + encodedURI;
	
	fetch('https://api-ssl.bitly.com/v4/shorten', {
	    method: 'POST',
		credentials: 'same-origin',
	    headers: {
	        'Authorization': 'Bearer e738a5f047e2c6498555fab79c8373e644f816c8',
	        'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({ 
			"long_url": url, 
			"domain": "bit.ly", 
			"group_guid": "" 
		})
	}).then(function (response) {
		response.json().then(function (content) {
			shareUrl = content.link;
			imageName = btoa(shareUrl).replace('==','--').replace('=','-');
			
			_this.configurator.ghdConfiguratorApi.getCameraLookAt(function(err, camera) {
			    let cameraPosition = camera.position; 
			    let cameraTarget = camera.target;
				
				// Disable User
				_this.configurator.ghdConfiguratorApi.setUserInteraction(false, function(err) {
				    if (!err) {
						// Move to Front Call Back
						_this.configurator.ghdConfiguratorApi.setCameraLookAt([0.034430530233974285, -1.4000315380747839, 1.8008216488796065], [0.0000812411, 0.0507833079, 1.250431576], 0, function(err) {
							if (!err) {
								setTimeout(() => { 
									// Capture Front Image
									_this.configurator.ghdConfiguratorApi.getScreenShot(1200,1800, function(err, frontDataRaw) {
									    if (!err) { 
											_this.configurator.ghdConfiguratorApi.setCameraLookAt([-0.017464614133418058, 1.5870154747415544, 1.471011937353166], [0.0000812411, 0.0507833079, 1.250431576], 0.01, function(err) {
												if (!err) {
													setTimeout(() => { 
														// Capture Back Image
														_this.configurator.ghdConfiguratorApi.getScreenShot(1200,1800, function(err, backDataRaw) {
														    if (!err) { 
																_this.formData = new FormData(_this);
																let preset_config = [];
																let variant_data = {};
																
																let productData = '';
																
																Array.from(_this.configurator.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).forEach(function (carousel) {
																	let item = carousel.selectedCell;
																		
																	let sectionTitle = item.closest('.ghd-configurator-carousel').getAttribute('section');
	
																	Array.from(item.querySelectorAll('.color-picker__option-values :checked')).forEach(function (item_value, index) {
																		let index1 = index + 1;
																		let material = item_value.closest('[material]').getAttribute('material');
																		let selectedOption = item_value.value;
		
																		if (!item_value.value.includes(material)) {
																			selectedOption = material + ' ' + item_value.value;
																		} 
		
																		if (item_value.closest('.material-card') && item_value.closest('.material-card').getAttribute('material-colour-code')) {
																			productData += sectionTitle + ' ' + index1 + ': ' + selectedOption + ' (' + item_value.closest('.material-card').getAttribute('material-colour-code') + ')<br>';
																		} else {
																			productData += sectionTitle + ' ' + index1 + ': ' + selectedOption + '<br>';
																		}
																	});
																	
																	if (_this.configurator.variantData[item.getAttribute('material')]) {
																		variant_data = _this.configurator.variantData[item.getAttribute('material')];
																	}
																});
														
																_this.formData.set("productData", JSON.stringify(productData));
																
																_this.formData.set("variantSku", variant_data['sku']);
																_this.formData.set("price", variant_data['price']);
																
																_this.formData.set("imageFrontName", imageName + "-Front.jpg");
																_this.formData.set("imageFrontData", frontDataRaw.replace('data:image/jpeg;base64,',''));
																_this.formData.set("imageBackName", imageName + "-Back.jpg");
																_this.formData.set("imageBackData", backDataRaw.replace('data:image/jpeg;base64,',''));
																_this.formData.set("shareUrl", shareUrl);
																
																let body_json = {};
																_this.formData.forEach((value, key) => body_json[key] = value);
																
																fetch(_this.submissionUrl + '?' + new URLSearchParams({
															        apikey: _this.submissionApiKey
															    }), {
																	body: JSON.stringify(body_json),
																	method: "POST",
																	mode: 'no-cors',
																	headers: {
																		'Content-Type': 'application/json',  
																		'X-Requested-With': 'XMLHttpRequest' 
																	}
															    }).then( 
																	response => { 
																		submitButtons.forEach((submitButton) => {
																			submitButton.innerText = 'Thank You For Your Submission'
																		});
																		
																		document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
																		_this.configurator.ghdConfiguratorApi.setCameraLookAt(cameraPosition, cameraTarget, 0, function(err) {
																			if (!err) {
																				_this.configurator.ghdConfiguratorApi.setUserInteraction(true, function(err) {
																					if (!err) {
																						_this.configurator.idle.start();
																					}
																				});
																			}
																		});
																	}
																).catch(
																	err => {
																		submitButtons.forEach((submitButton) => {
																			submitButton.innerText = 'Error - Please Try Again'
																			setTimeout(() => { 
																				submitButton.innerText = 'Send Message'
																			}, 3000);
																			submitButton.removeAttribute("disabled");
																			submitButton.removeAttribute("aria-busy");
																		});
																		document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
																		_this.configurator.ghdConfiguratorApi.setCameraLookAt(cameraPosition, cameraTarget, 0, function(err) {
																			if (!err) {
																				_this.configurator.ghdConfiguratorApi.setUserInteraction(true, function(err) {
																					if (!err) {
																						_this.configurator.idle.start();
																					}
																				});
																			}
																		});
																	}
																	
																);
														    }
														});
													}, 500);
												}
											});
									    }
									});
								}, 500);
							}
						});
				    }
				});
			});
		});
	});
};

if (!window.customElements.get("team-shop-form")) {
	window.customElements.define("team-shop-form", TeamShopForm, { extends: "form" });
}


let GHDConfiguratorModal = class extends Modal {
	constructor() {
		super();
		if (this.shouldAppendToBody) {
			document.body.append(this);
		}
	}
  
	get shouldAppendToBody() {
		return this.hasAttribute("append-to-body");
	}
  
};

if (!window.customElements.get("ghd-configurator-modal")) {
  window.customElements.define("ghd-configurator-modal", GHDConfiguratorModal);
}


let _delegate_GHDScrollCarousel, _onOptionChanged_GHDScrollCarousel, onOptionChanged_fn_GHDScrollCarousel;

let GHDScrollCarousel = class extends ScrollCarousel {
	constructor() {
		super();
		__privateAdd(this, _delegate_GHDScrollCarousel, new Delegate(this));
		__privateAdd(this, _onOptionChanged_GHDScrollCarousel);
		
		__privateGet(this, _delegate_GHDScrollCarousel).on("change", '.color-picker__option-values input', __privateMethod(this, _onOptionChanged_GHDScrollCarousel, onOptionChanged_fn_GHDScrollCarousel).bind(this));
	}
	
	connectedCallback() {
		__privateMethod(this, _onOptionChanged_GHDScrollCarousel, onOptionChanged_fn_GHDScrollCarousel).call(this);
	}
};

_onOptionChanged_GHDScrollCarousel = new WeakSet();
onOptionChanged_fn_GHDScrollCarousel = function(event) {
	let selectedOption = this.querySelector(':checked + .color-swatch');
    if (this.hasAttribute("align-selected") && (this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight)) {
		
      this.scrollTo({
        left: selectedOption.offsetLeft - this.clientWidth / 2 + selectedOption.clientWidth / 2,
        top: selectedOption.offsetTop - this.clientHeight / 2 + selectedOption.clientHeight / 2,
        behavior: matchesMediaQuery("motion-safe") ? "smooth" : "auto"
      });
    }
};

_delegate_GHDScrollCarousel = new WeakMap();

if (!window.customElements.get("ghd-scroll-carousel")) {
  window.customElements.define("ghd-scroll-carousel", GHDScrollCarousel);
}


var GHDCopyButton = class extends HTMLButtonElement {
  constructor() {
    super();
  }
  connectedCallback() {
	  if (!this.copyField) {
	    throw "Copy button component requires an aria-controls attribute that refers to the controlled copy field.";
	  }
	  
      let _this = this;
	  
      this.addEventListener("click", (event) => {
		event.preventDefault();
  		
		navigator.clipboard.writeText(_this.copyField.innerText);
		  		
		_this.innerText = 'Copied!';
		
  		setTimeout(() => { 
			_this.innerText = 'Copy Link';
  		}, 3000);
      });
  }
  
  get copyField() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
if (!window.customElements.get("ghd-copy-button")) {
  window.customElements.define("ghd-copy-button", GHDCopyButton, { extends: "button" });
}


let _delegate, 
	_changeActiveSectionView,
	changeActiveSectionView_fn,
	_changeActiveSection,
	changeActiveSection_fn,
	_generatePreset,
	generatePreset_fn,
	_generateShareLink,
	generateShareLink_fn;

let GHDConfigurator = class extends HTMLElement {
	constructor() {
		super();
		
		__privateAdd(this, _delegate, new Delegate(this));
		__privateAdd(this, _changeActiveSectionView);
		__privateAdd(this, _changeActiveSection);
		__privateAdd(this, _generatePreset);
		__privateAdd(this, _generateShareLink);

		this.gradientMasks = [];
		this.printedGradients = [];
		this.views = [];
		this.includesMeshPrev = false;
		this.includesMesh = false;
		this.meshTextureUID = '';
		
		this.baseMaterials = __GHDConfiguratorBaseMaterials(this.uvScale);
		this.customMaterials = __GHDConfiguratorCustomMaterials();
		
		if (window.location.search.includes('configurator=')) {
			this.parentModal.show();
		};
		
		this._activateSketchFab();
	}
	
	connectedCallback() {
        this.addEventListener("configurator:option:change", (event) => this._updateSelectedOptions(event));
		this.addEventListener("configurator:section:change", (event) => __privateMethod(this, _changeActiveSectionView, changeActiveSectionView_fn).call(this, event));
		this.addEventListener("configurator:view:change", (event) => __privateMethod(this, _changeActiveSection, changeActiveSection_fn).call(this, event.detail.view));
		
		__privateGet(this, _delegate).on("click", '.generate-preset', __privateMethod(this, _generatePreset, generatePreset_fn).bind(this));
		__privateGet(this, _delegate).on("click", '.generate-share-url', __privateMethod(this, _generateShareLink, generateShareLink_fn).bind(this));
		
	}
	
	get uid() {
		return this.getAttribute('model-id');
	}
	
	get uvScale() {
		return this.getAttribute('uv-scale');
	}
	
	get parentModal() {
		return document.getElementById(this.getAttribute('modal-id'));
	}
	
	get textureUrls() {
		return JSON.parse(this.getAttribute('texture-urls'));
	}
	
	get variantData() {
		return JSON.parse(this.getAttribute('variant-data'));
	}
	
	get gradientUrls() {
		return JSON.parse(this.getAttribute('gradient-urls'));
	}
	
	get iframe() {
		return document.getElementById('frame-' + this.uid);
	}
	
	_onlyUnique(value, index, self) { 
	    return self.indexOf(value) === index;
	}
	
	_loadPreset(config, event) {
		console.log('Config Update');
		this.disableUpdate = true;
		
		let _this = this;
		config.forEach(function (section, index) {
			let carousel = document.querySelector('[section="' + section.section + '"]');
			let material = section.material;
			let newIndex = 0;
			
			if (carousel.cells.findIndex((cell) => cell.getAttribute("material") === material) >= 0) {
				newIndex = carousel.cells.findIndex((cell) => cell.getAttribute("material") === material)
			} else if (carousel.cells.findIndex((cell) => cell.getAttribute("material-handle") === material) >= 0) {
				newIndex = carousel.cells.findIndex((cell) => cell.getAttribute("material-handle") === material)
			}
			
			carousel.select(newIndex, {instant: true});

			let valueSelectors = carousel.selectedCell.querySelector('.ghd-configurator-carousel').cells;

			Array.from(valueSelectors).forEach(function (valueSelector, child_index) {
				if (valueSelector.querySelector('[value="' + section.values[child_index] + '"]')) {
					valueSelector.querySelector('[value="' + section.values[child_index] + '"]').checked = true;
				} else if (valueSelector.querySelector('.material-card[material-colour-handle="' + section.values[child_index] + '"]')) {
					valueSelector.querySelector('.material-card[material-colour-handle="' + section.values[child_index] + '"] input').checked = true;
				}
			});
		});
				
		setTimeout(() => { 
			_this.disableUpdate = false;
			_this._updateSelectedOptions();
		}, 500);
		
	}	
	
	_sketchFabSuccess(api) {
		let _this = this;
		this.ghdConfiguratorApi = api;
		
		this.ghdConfiguratorApi.start(function () {
			_this.ghdConfiguratorApi.addEventListener('viewerready', function () {
		
				_this.ghdConfiguratorApi.setCameraLookAt([0.01087173775914819, -1.1020543060598422, 1.5833715120563805], [0.0000812411, 0.0507833079, 1.250431576], 0, function(err) {
					if (err) {
						window.console.log(err);
					}
				});
				
				_this.idle = createIdleObjectMatrixSway(api, {
					axis: [0, 1, 0],
    				angleDeg: 6,
    				speed: 0.22,      
    				maxFps: 30,
					autostart: true,
    				restoreOnStop: true,
    				debug: false,
					pauseOnUserCamera: true,
    				resumeAfterMs: 5000,
    				rebaseOnResume: true,
					restartFromBeginning: true, 
    				rampMs: 2000,
				});

				_this.idle.init();
				
					
				let promiseArray = [];
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.getSceneGraph(function(err, graph) {
						if (!err) {
							_this.modelNodes = graph.children[0].children;
							resolve();
						}
					});
				}));
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.addTexture(_this.textureUrls['mystique'], function(err, textureUid) {
						if (!err) {
							_this.baseMaterials['dyed-mystique'].RoughnessPBR.texture.uid = textureUid;
							resolve();
						}
					});
				}));
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.addTexture(_this.textureUrls['mesh'], function(err, textureUid) {
						if (!err) {
							_this.meshTextureUID = textureUid;
							_this.baseMaterials['dyed-mesh'].Opacity.texture.uid = textureUid;
							_this.baseMaterials['dyed-fog-mesh'].Opacity.texture.uid = textureUid;
							_this.baseMaterials['printed-mesh'].Opacity.texture.uid = textureUid;
							resolve();
						}
					});
				}));
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.addTexture(_this.textureUrls['diamond-mesh'], function(err, textureUid) {
						if (!err) {
							_this.diamondMeshTextureUID = textureUid;
							_this.baseMaterials['dyed-diamond-mesh'].Opacity.texture.uid = textureUid;
							resolve();
						}
					});
				}));
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.getAnnotationList(function(err, views) {
					    if (!err) {
							for (let i = 0; i < views.length; i++) {
								_this.views[views[i].name] = i;
							}
							resolve();
					    }
					});
				}));
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.addTexture(_this.textureUrls['dizzy'], function(err, textureUid) {
						if (!err) {
							_this.baseMaterials['crystal'].Sheen.texture.uid = textureUid;
							resolve();
						}
					});
				}));
				
				promiseArray.push(new Promise((resolve, reject) => {
					_this.ghdConfiguratorApi.getMaterialList(function (err, materials) {
						_this.modelMaterials = materials;
						
						for (let i = 0; i < _this.modelMaterials.length; i++) {
							if (_this.modelMaterials[i].name == 'clip') {
								_this.clipIndex = i;
							} else if (_this.modelMaterials[i].name == 'lining') {
								_this.liningIndex = i;
							} else if (_this.modelMaterials[i].name == 'back_lining') {
								_this.liningBackIndex = i;
							}
						}
						resolve();
					});
				}));
				
				let initialGradientGroups = [];
				Array.from(_this.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).forEach(function (carousel) {
					Array.from(carousel.selectedCell.querySelectorAll('.color-picker__option-values .color-swatch')).forEach(function (item) {
						if (item.closest('.color-picker__option-values').getAttribute('model-method') == 'merge') {
							initialGradientGroups.push(item.closest('.color-picker__option-values').getAttribute('model-reference').substring(0, item.closest('.color-picker__option-values').getAttribute('model-reference').length - 2));
						};
					});
				});
				
				initialGradientGroups = initialGradientGroups.filter( _this._onlyUnique );
				
				for (let i = 0; i < initialGradientGroups.length; i++) {
					promiseArray.push(new Promise((resolve, reject) => {
						_this.ghdConfiguratorApi.addTexture(_this.textureUrls['mystique'], function(err, textureUid) {
							if (!err) {
								_this.printedGradients[initialGradientGroups[i]] = textureUid;
								resolve();
							}
						});
					}));
				};
				
				for (let i = 0; i < _this.gradientUrls.length; i++) {
					promiseArray.push(new Promise((resolve, reject) => {
					    const image = new Image();
					    image.addEventListener('load', () => {
							_this.gradientMasks[_this.gradientUrls[i].section] = image;
							resolve();
					    });
						
					    image.addEventListener('error', () => {
							resolve();
					    });
					    image.src = _this.gradientUrls[i].src;
					}));
				};
				
				_this.ghdConfiguratorApi.addEventListener('click', function (info) {
					if (info.material != null) {
						__privateMethod(_this, _changeActiveSection, changeActiveSection_fn).call(_this, info.material.name);
					}
				}, {
					pick: 'fast'
				});
				
				Promise.all(promiseArray).then(results => {
					const urlParams = new URLSearchParams(window.location.search);
					const share_config = urlParams.get('configurator');
					if (share_config) {
						let config = JSON.parse(decodeURIComponent(share_config)).config;
						_this._loadPreset(config);
					}
					
					_this._updateSelectedOptions();
					
					Array.from(_this.querySelectorAll('.material-card input')).forEach(function (item) {
						item.addEventListener("change", (event) => _this._updateSelectedOptions(event));
					});
				});
				
				_this.dispatchEvent(new CustomEvent("configurator:init", {
					bubbles: true
				}));
			});
		});
	}
	
	_sketchFabError() {
		console.error('Sketchfab API error');
	}
	
	_fadeIn(material, delay) {
		let _this = this;
		var fadeInTimer;
		let i = 0;
		
  		setTimeout(() => { 
			const fadeIn = () => {
				if (i > 30) {
					window.clearInterval(fadeInTimer);
			  		setTimeout(() => { 
						_this._fadeOut(material);
			  		}, 1400);
				} else {
					_this._setFadeFactor(material, i / 75);
					i++;
				}
			};
			fadeInTimer = window.setInterval(fadeIn, 10);
  		}, delay);
	}
	
	_fadeOut(material) {
		let _this = this;
		var fadeOutTimer;
		let i = 30;
		const fadeOut = () => {
			if (i < 0) {
				window.clearInterval(fadeOutTimer);
			} else {
				_this._setFadeFactor(material, i / 75);
				i--;
			}
		};
		fadeOutTimer = window.setInterval(fadeOut, 10);
	}
	
	_setFadeFactor(material, factor) {
		material.channels.EmitColor.enable = true;
		material.channels.EmitColor.factor = factor;
		material.channels.EmitColor.color = [1.0, 1.0, 1.0];
		this.ghdConfiguratorApi.setMaterial(material);
	}
	
	_activateSketchFab() {
		const client = new window.Sketchfab(this.iframe);
		
		let sketchFabConfig = {
			success: this._sketchFabSuccess.bind(this),
			error: this._sketchFabError.bind(this),
			autostart: 1,
			preload: 0,
			ui_infos: 0,
			ui_stop: 0,
			ui_controls: 0,
			ui_loading: 0,
			ui_inspector: 0,
			ui_watermark: 0,
			ui_help: 0,
			ui_hint: 0,
			ui_vr: 0,
			prevent_user_light_rotation: 1,
			annotations_visible: 0,
			annotation: 100
		}
		
		client.init(this.uid, sketchFabConfig);
	}	
	
	_updateSelectedOptions(event) {
		if (!this.disableUpdate) {
			console.log('Update Selected Options');
			let _this = this;
			this.selectedOptions = [];
			Array.from(this.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).forEach(function (carousel) {
				Array.from(carousel.selectedCell.querySelectorAll('.color-picker__option-values :checked')).forEach(function (item) {
					_this.selectedOptions.push({
						mesh: item.closest('.color-picker__option-values').getAttribute('model-reference'),
						method: item.closest('.color-picker__option-values').getAttribute('model-method'),
						material: item.closest('.material-card').getAttribute('material-colour-handle'),
						title: item.closest('.material-card').getAttribute('material-colour-title'),
						parent_material: item.closest('.parent-material').getAttribute('material')
					});
				});
			});
			
			Array.from(this.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).every(function (carousel) {
				let item = carousel.selectedCell;
				if (_this.variantData[item.getAttribute('material')]) {
					_this._updatePrice(_this.variantData[item.getAttribute('material')].priceHTML);
					return false;
				}
				return true;
			});
			
			this._prepareGradientData();
		}
	}
	
	_updatePrice(priceHTML) {
		this.querySelector('.price-list-wrapper').innerHTML = priceHTML;
	}
	
	_prepareGradientData() {
		console.log('Prepare Gradient Data');
	
		// Prepare Gradient Data
		let gradientSections = [],
			gradientGroups = this.gradientGroups || [],
			promiseArray = [],
			_this = this;
			
		this.gradientGroups = [];	

		// create a list of all section including 'printed' in title and stip off numbering
		for (let j = 0; j < this.selectedOptions.length; j++) {
			if (this.selectedOptions[j].method == 'merge') {
				let gradientSection = this.selectedOptions[j].mesh.substring(0, this.selectedOptions[j].mesh.length - 2); 
				gradientSections.push(gradientSection);
			};
		};
	
		// filter for only unique gradient sections
		gradientSections = gradientSections.filter( this._onlyUnique );
	
		// Get values for each gradient stop		
		for (let p = 0; p < gradientSections.length; p++) {
			let gradientSectionOptions = [],
				gradientSectionTitles = [],
				gradientSectionTitle = gradientSections[p],
				first = true,
				gradientBaseMaterial = '',
				additionalClasses = '',
				gradientParentMaterial = '';
		
			for (let j = 0; j < this.selectedOptions.length; j++) {
			
				let selectedOption = this.selectedOptions[j].material.trim();
				
				if (this.selectedOptions[j].mesh.includes(gradientSectionTitle)) {
				
					if (first == true) {
						gradientBaseMaterial = this.customMaterials[selectedOption].pbrSpecification.baseMaterial;
						first = false;
					}
				
					let rgbArray = _hexToRGB(this.customMaterials[selectedOption].hexCode, true);
					gradientSectionOptions.push('rgb(' + (255 * rgbArray[0]) + ', ' + (255 * rgbArray[1]) + ', ' + (255 * rgbArray[2]) + ')');
					gradientSectionTitles.push(this.selectedOptions[j].title);
					gradientParentMaterial = this.selectedOptions[j].parent_material;
				};
			};
		
			this.gradientGroups.push({
				fabricSection: gradientSectionTitle, // printed_a
				gradiantValues: gradientSectionOptions, // array of hex codes
				gradiantTitles: gradientSectionTitles, // array of titles
				gradientBaseMaterial: gradientBaseMaterial, // printed_matt
				gradientParentMaterial: gradientParentMaterial,
				initialised: true,
			});
		};
	
		for (let j = 0; j < this.gradientGroups.length; j++) {
		
			if (this.gradientGroups[j].initialised) {

				let gradientTitle = this.gradientGroups[j].fabricSection,
					gradientTextureCanvas;

				if (JSON.stringify(this.gradientGroups[j]) != JSON.stringify(gradientGroups[j])) {
					// generate gradient images
					if (this.gradientGroups[j].gradiantValues.length == 3) {
						gradientTextureCanvas =  this._generateGradient(gradientTitle,this.gradientGroups[j].gradiantValues[0],this.gradientGroups[j].gradiantValues[1],this.gradientGroups[j].gradiantValues[2]);
					} else if (this.gradientGroups[j].gradiantValues.length == 2) {
						gradientTextureCanvas =  this._generateGradient(gradientTitle,this.gradientGroups[j].gradiantValues[0],this.gradientGroups[j].gradiantValues[1],null);
					} else {
						gradientTextureCanvas =  this._generateGradient(gradientTitle,this.gradientGroups[j].gradiantValues[0],null,null);
					};
					let gradientTextureSwatch = gradientTextureCanvas.toDataURL("image/webp");
					
					promiseArray.push(new Promise((resolve, reject) => {
						_this.ghdConfiguratorApi.updateTexture(gradientTextureSwatch, _this.printedGradients[gradientTitle], function(err, textureUid) {
							resolve();
						});
					}));
				}
		
				// remove original seperate image list items
				for (let p = this.selectedOptions.length -1; p >= 0; p--) {
					if (this.selectedOptions[p].mesh.includes(gradientTitle)) {
						this.selectedOptions.splice([p], 1);
					};
				};
		
				// generate new merged image list item
				this.selectedOptions.push({
					mesh: gradientTitle,
					method: 'merge',
					material: this.gradientGroups[j].gradientBaseMaterial,
					title: this._formatList(this.gradientGroups[j].gradiantTitles),
					parent_material: this.gradientGroups[j].gradientParentMaterial
				});
			}
		};
		
		Promise.all(promiseArray).then(results => {
			_this._updateModel();
		});
	}
	
	_formatList(arr) {
		if (arr.length === 0) {
			return "";
		} else if (arr.length === 1) {
			return arr[0];
		} else {
			const allButLast = arr.slice(0, -1).join(', ');
			const last = arr[arr.length - 1];
			return `${allButLast} & ${last}`;
		}
	}
	
	_generateGradient(gradientTitle, value1, value2, value3) {
		console.log('Generate Gradient');
	
		// Gradient Texture
	    let canvas = document.createElement('canvas'),
	    ctx = canvas.getContext("2d", { willReadFrequently: true }),
		canvasProxy = document.createElement('canvas'),
		ctxProxy = canvasProxy.getContext("2d", { willReadFrequently: true });

		if (value2 != null && this.gradientMasks[gradientTitle + '_2'] && value3 == null || value2 != null && this.gradientMasks[gradientTitle + '_2'] && value3 != null && this.gradientMasks[gradientTitle + '_3']) {
			// Execute gradient mask method
			let img = this.gradientMasks[gradientTitle + '_2'];
			let canvasSize = img.width;
		    canvas.width = canvasSize;
		    canvas.height = canvasSize;
		
			 // Generate proxy canvas
		  	canvasProxy.width = canvasSize;
		  	canvasProxy.height = canvasSize;
		
			// Generate gradient colour 1
		    ctx.fillStyle = value1;
		    ctx.fillRect(0, 0, canvas.width, canvas.height);	
			if (value2 != null) {
			  	// Generate gradient colour 2
				
			    ctxProxy.globalCompositeOperation = "source-over";
			    ctxProxy.drawImage(img, 0, 0);
			    let idata = ctxProxy.getImageData(0, 0, canvasProxy.width, canvasProxy.height);
			    let data32 = new Uint32Array(idata.data.buffer);
			    let i = 0, len = data32.length;
			    while(i < len) data32[i] = data32[i++] << 8;
			    ctxProxy.putImageData(idata, 0, 0);
			    ctxProxy.globalCompositeOperation = "source-in";
			    ctxProxy.fillStyle = value2;
			    ctxProxy.fillRect(0, 0, canvasProxy.width, canvasProxy.height);
			  	ctx.drawImage(canvasProxy, 0, 0);
			}
		
			if (value3 != null) {
			  	// Generate gradient colour 3
				let img = this.gradientMasks[gradientTitle + '_3'];
			    ctxProxy.globalCompositeOperation = "source-over";
			    ctxProxy.drawImage(img, 0, 0);
			    let idata = ctxProxy.getImageData(0, 0, canvasProxy.width, canvasProxy.height);
			    let data32 = new Uint32Array(idata.data.buffer);
			    let i = 0, len = data32.length;
			    while(i < len) data32[i] = data32[i++] << 8;
			    ctxProxy.putImageData(idata, 0, 0);
			    ctxProxy.globalCompositeOperation = "source-in";
			    ctxProxy.fillStyle = value3;
			    ctxProxy.fillRect(0, 0, canvasProxy.width, canvasProxy.height);
			  	ctx.drawImage(canvasProxy, 0, 0);
			}
		} else {
		    canvas.width = 128;
		    canvas.height = 128;
			let gradient;

			if (value3 != null) {
				gradient = ctx.createLinearGradient( 64, 0, 64, 128 );
				gradient.addColorStop(
					(0.5 * (0.2 / this.uvScale) + 0.5).toFixed(2), value3
				);
				gradient.addColorStop(0.5, value2);
				gradient.addColorStop(
					(0.5 * (-0.2 / this.uvScale) + 0.5).toFixed(2), value1
				);
			} else if (value2 != null) {
				gradient = ctx.createLinearGradient( 64, 0, 64, 128 );
				gradient.addColorStop(
					(0.5 * (0.2 / this.uvScale) + 0.5).toFixed(2), value2
				);
				gradient.addColorStop(
					(0.5 * (-0.2 / this.uvScale) + 0.5).toFixed(2), value1
				);
			} else {
				gradient = ctx.createLinearGradient( 64, 0, 64, 128 );
				gradient.addColorStop(0.5, value1);
			}
	
		    ctx.fillStyle = gradient;
			ctx.fillRect(0,0,128,128);
		}

		return canvas;
	}
	
	_reformatAndMergeCrystals(arr) {
		const crystals = [];
		const out = [];

		for (const { mesh, title, parent_material } of arr) {
			if (mesh.includes("crystals")) {
				crystals.push({ title, parent_material });
			} else {
				out.push({ mesh, title });
			}
		}

		if (crystals.length) {
			const parent = crystals[0].parent_material;
			const titles = crystals.map(c => c.title);

			const formattedTitles =
				titles.length === 1
				? titles[0]
		        : titles.length === 2
		        ? titles.join(" & ")
		        : `${titles.slice(0, -1).join(", ")} & ${titles[titles.length - 1]}`;

		    out.push({
		      mesh: "crystals",
		      title: `${parent} ${formattedTitles}`
		    });
		}

		return out;
	}
	
	_updateModel() {
		console.log('Update Model');
		this.includesMeshPrev = this.includesMesh;
		this.includesMesh = false;
		
		let _this = this;
		
		const summaryArray = this._reformatAndMergeCrystals(this.selectedOptions);
		for (let j = 0; j < summaryArray.length; j++) {
			let summaryButtons = this.querySelectorAll('[view="' + summaryArray[j].mesh + '"].summary-option');
			summaryButtons.forEach((summaryButton) => {
				summaryButton.innerHTML = summaryArray[j].title;
			});
		}
	
		// Hide Object Logic
		for (let i = 0; i < this.modelNodes.length; i++) {
			let modelNodeActive = false;			
		
			if (this.modelNodes[i].name.includes('clip') || this.modelNodes[i].name.includes('lining')) {
				continue;
			}
								
			for (let j = 0; j < this.selectedOptions.length; j++) {
				let mesh = this.selectedOptions[j].mesh;
				if (mesh.includes(this.modelNodes[i].name.substring(0, this.modelNodes[i].name.lastIndexOf("_")))) {
					modelNodeActive = true;
				}
			}
		
			if (modelNodeActive != this.modelNodes[i].isActive) {
			
				if (modelNodeActive == true && this.modelNodes[i].isActive != true) {
					this.ghdConfiguratorApi.show(this.modelNodes[i].instanceID);
					this.modelNodes[i].isActive = true;
				} else if (modelNodeActive == false) {
					this.ghdConfiguratorApi.hide(this.modelNodes[i].instanceID);
					this.modelNodes[i].isActive = false;
				}
			}
		}
	
		// Update Materials Logic
		for (let i = 0; i < this.modelMaterials.length; i++) {
			let m = this.modelMaterials[i];
		
			for (let j = 0; j < this.selectedOptions.length; j++) {
				let selectedOption = this.selectedOptions[j].material.trim();
				let method = this.selectedOptions[j].method;
				let fabricSection = this.selectedOptions[j].mesh;				
			
				if (fabricSection.includes(m.name)) {
			
					// Lining Trigger Logic
					if (selectedOption.includes('mesh')) {
						this.includesMesh = true;
					}
				
					if (method == 'merge' || selectedOption != m.selectedOption) {
					
						// Clip Logic
						if (this.clipIndex && m.name.includes('section_a')) {
							if (selectedOption.includes('black')) {
								if (this.modelMaterials[this.clipIndex].selectedOption != 'black_clip') {
									this.modelMaterials[this.clipIndex].selectedOption = 'black_clip';
									this.modelMaterials[this.clipIndex].channels.Opacity.enable = false;
									this.modelMaterials[this.clipIndex].channels.EmitColor.enable = false;
									this.modelMaterials[this.clipIndex].channels.DiffusePBR.color = _hexToRGB('#222222');
									this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.clipIndex]);
								}
							} else if (selectedOption.includes('white')) {
								if (this.modelMaterials[this.clipIndex].selectedOption != 'white_clip') {
									this.modelMaterials[this.clipIndex].selectedOption = 'white_clip';
									this.modelMaterials[this.clipIndex].channels.Opacity.enable = false;
									this.modelMaterials[this.clipIndex].channels.EmitColor.enable = true;
									this.modelMaterials[this.clipIndex].channels.DiffusePBR.color = _hexToRGB('#E7E7E7');
									this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.clipIndex]);
								}
							} else {
								if (this.modelMaterials[this.clipIndex].selectedOption != 'clear_clip') {
									this.modelMaterials[this.clipIndex].selectedOption = 'clear_clip';
									this.modelMaterials[this.clipIndex].channels.Opacity.enable = true;
									this.modelMaterials[this.clipIndex].channels.Opacity.factor = 0.25;
									this.modelMaterials[this.clipIndex].channels.EmitColor.enable = true;
									this.modelMaterials[this.clipIndex].channels.DiffusePBR.color = _hexToRGB('#E7E7E7');
									this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.clipIndex]);
								}
							}
						}
					
						if (method == 'merge') {
						
							// Update gradient material channels
						
							let forceOpacityOverride = false,
								originalOpacityValues,
								originalAlphaValues;
						
							if (m.channels.Opacity && m.channels.Opacity.texture && m.channels.Opacity.texture.uid && m.channels.Opacity.texture.uid != this.meshTextureUID && m.channels.Opacity.texture.uid != this.diamondMeshTextureUID) {
								// Pattern found, forcing opacity overrides
								originalOpacityValues = JSON.parse(JSON.stringify(m.channels.Opacity)); 
								forceOpacityOverride = true;
							}
						
							let forceAlphaOverride = false;
							if (m.channels.AlphaMask && m.channels.AlphaMask.texture && m.channels.AlphaMask.texture.uid) {
								// Pattern found, forcing alpha overrides
								originalAlphaValues = JSON.parse(JSON.stringify(m.channels.AlphaMask)); 
								forceAlphaOverride = true;
							}
						
							m.channels = JSON.parse(JSON.stringify(this.baseMaterials[selectedOption]));
							m.selectedOption = selectedOption;
							m.channels.DiffusePBR.texture.uid = this.printedGradients[fabricSection];
							if (forceOpacityOverride) {
								m.channels.Opacity = originalOpacityValues;
							}
						
							if (forceAlphaOverride) {
								m.channels.AlphaMask = originalAlphaValues;
							}
						} else {
							// Update normal material channels
							m.channels = JSON.parse(
								JSON.stringify(
									this.baseMaterials[this.customMaterials[selectedOption].pbrSpecification.baseMaterial]
								)
							);
						
							m.selectedOption = selectedOption;
						
							for (let channel in this.customMaterials[selectedOption].pbrSpecification.customisations) {
							    for (let key in this.customMaterials[selectedOption].pbrSpecification.customisations[channel]) {
									m.channels[channel][key] = this.customMaterials[selectedOption].pbrSpecification.customisations[channel][key];
								}
							}
						
						}
					
						this.ghdConfiguratorApi.setMaterial(m);
						
						
					} 
				
					break;
				}
			}
		}
	
		// Lining Logic
		if (this.includesMeshPrev != this.includesMesh) {
			console.log('Update Lining');
			if (this.includesMesh) {
				this.modelMaterials[this.liningIndex].channels = this.baseMaterials['lining'];
				this.modelMaterials[this.liningIndex].channels.DiffusePBR.color = _hexToRGB('#BA9983');
				this.modelMaterials[this.liningIndex].channels.SpecularPBR.color = _hexToRGB('#222222');
				this.modelMaterials[this.liningIndex].channels.Opacity.factor = 1;
				this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.liningIndex]);
			
				if (this.liningBackIndex != null) {
					this.modelMaterials[this.liningBackIndex].channels = this.baseMaterials['lining'];
					this.modelMaterials[this.liningBackIndex].channels.DiffusePBR.color = _hexToRGB('#BA9983');
					this.modelMaterials[this.liningBackIndex].channels.SpecularPBR.color = _hexToRGB('#222222');
					this.modelMaterials[this.liningBackIndex].channels.Opacity.factor = 1;
					this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.liningBackIndex]);
				}
			} else {
				this.modelMaterials[this.liningIndex].channels = this.baseMaterials['lining'];
				this.modelMaterials[this.liningIndex].channels.DiffusePBR.color = _hexToRGB('#FFFFFF');
				this.modelMaterials[this.liningIndex].channels.Opacity.factor = 1;
				this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.liningIndex]);
			
				if (this.liningBackIndex != null) {
					this.modelMaterials[this.liningBackIndex].channels = this.baseMaterials['lining'];
					this.modelMaterials[this.liningBackIndex].channels.Opacity.factor = 0;
					this.ghdConfiguratorApi.setMaterial(this.modelMaterials[this.liningBackIndex]);
				}
			}
		}
	};
}

_generatePreset = new WeakSet();
generatePreset_fn = function(event) {
	let preset_config = [];
	Array.from(this.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).forEach(function (carousel) {
		let item = carousel.selectedCell;
		let values = [];
		Array.from(item.querySelectorAll('.color-picker__option-values :checked')).forEach(function (item_value) {
			values.push(item_value.closest('.material-card').getAttribute('material-colour-handle'));
		});
		
		preset_config.push({
			section: item.closest('.ghd-configurator-carousel').getAttribute('section'),
			material: item.getAttribute('material-handle'),
			values
		});
		
	});
	
	let json_preset = JSON.stringify({ "config": preset_config });

	alert(json_preset);
};

_generateShareLink = new WeakSet();
generateShareLink_fn = function(event) {
	let preset_config = [];
	let _this = this;
	Array.from(this.querySelectorAll('.ghd-configurator-carousel[tier="2"]')).forEach(function (carousel) {
		let item = carousel.selectedCell;
		let values = [];
		Array.from(item.querySelectorAll('.color-picker__option-values :checked')).forEach(function (item_value) {
			values.push(item_value.closest('.material-card').getAttribute('material-colour-handle'));
		});
		
		preset_config.push({
			section: item.closest('.ghd-configurator-carousel').getAttribute('section'),
			material: item.getAttribute('material-handle'),
			values
		});
	});
	
	let json_preset = JSON.stringify({ "config": preset_config });
	let encodedURI = encodeURIComponent(json_preset);
	let url = window.location.origin + window.location.pathname + '?' + 'configurator=' + encodedURI;
	
	fetch('https://api-ssl.bitly.com/v4/shorten', {
	    method: 'POST',
		credentials: 'same-origin',
	    headers: {
	        'Authorization': 'Bearer e738a5f047e2c6498555fab79c8373e644f816c8',
	        'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({ 
			"long_url": url, 
			"domain": "bit.ly", 
			"group_guid": "" 
		})
	}).then(function (response) {
	    response.json().then(function (content) {
			_this.querySelector('.social--share-inner').innerText = content.link
		});
	});
};

_changeActiveSectionView = new WeakSet();
changeActiveSectionView_fn = function(event) {
	console.log('Change Active Section View');
	let _this = this;
	
	if (this.views && this.views[event.detail.view] != null) {
		
		this.activeView = event.detail.view;
	
		let summaryButtons = this.querySelectorAll('.configurator-summary--option');
		summaryButtons.forEach((summaryButton) => {
			if (summaryButton.querySelector('.summary-option').getAttribute('view') == _this.activeView) {
				summaryButton.classList.add('active');
			} else {
				summaryButton.classList.remove('active');
			}
		});
		
		this.ghdConfiguratorApi.gotoAnnotation(this.views[event.detail.view], { 
			preventCameraAnimation: false, 
			preventCameraMove: false
		}, function(err, index) {
			for (const modelMaterial of _this.modelMaterials) {
				if (modelMaterial.name == event.detail.view) {
					_this._fadeIn(modelMaterial, 0);
					break;
				}
			}
		});
	};
}

_changeActiveSection = new WeakSet();
changeActiveSection_fn = function(section) {
	console.log('Change Active Section');
	if (section.includes('crystals')) {
		section = 'crystals';
	}
		
	// crystals_heavy_1
	if (this.querySelector('button[view="' + section + '"]:not(.summary-button)')) {
		this.querySelector('button[view="' + section + '"]:not(.summary-button)').click();
	}
}

_delegate = new WeakMap();

let _updateSelectedOptions_GHDConfiguratorPreset, 
	updateSelectedOptions_fn_GHDConfiguratorPreset;

let GHDConfiguratorPreset = class extends HTMLElement {
	constructor() {
		super();
		__privateAdd(this, _updateSelectedOptions_GHDConfiguratorPreset);
		this.addEventListener("click", (event) => __privateMethod(this, _updateSelectedOptions_GHDConfiguratorPreset, updateSelectedOptions_fn_GHDConfiguratorPreset).call(this, event));
	}
	
	connectedCallback() {
	    if (!this.configurator) {
	      throw "Preset component requires an aria-controls attribute that refers to the controlled configurator.";
	    }
	}
	
	get config() {
		return JSON.parse(this.getAttribute("config"));
	}
	
    get configurator() {
      return document.getElementById(this.getAttribute("aria-controls"));
    }
	
};

_updateSelectedOptions_GHDConfiguratorPreset = new WeakSet();
updateSelectedOptions_fn_GHDConfiguratorPreset = function(event) {
	this.configurator._loadPreset(this.config.config, event);
};


if (!window.customElements.get("ghd-configurator")) {
	let undefinedCustomElements = [],
		requiredCustomElements = [
			'ghd-configurator-modal'
		],
		customElements = Array.from(document.querySelectorAll(':not(:defined)'));

	customElements.forEach(function(item) {
		if (item.tagName.includes("-") && requiredCustomElements.includes(item.localName)) {
			undefinedCustomElements.push(item);
		}
	});

	let promises = [...undefinedCustomElements].map((item) => {
		return window.customElements.whenDefined(item.localName);
	});

	Promise.all(promises).then(() => {
		window.customElements.define("ghd-configurator", GHDConfigurator);
		if (!window.customElements.get("ghd-configurator-preset")) {
		  window.customElements.define("ghd-configurator-preset", GHDConfiguratorPreset);
		}
	});
}

export {
	GHDConfigurator
};

